import React from 'react';
import PropTypes from 'prop-types';
import { X } from 'lucide-react';

/**
 * QuizResultModal - Display the recommended valuation method from quiz results
 * Shows the selected method with details and prompts user to continue
 */
const QuizResultModal = ({ isOpen, onClose, quizRecommendation }) => {
  if (!isOpen || !quizRecommendation) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-2 sm:p-4">
      <div className="bg-white rounded-lg w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-between items-start mb-4">
            <h2 className="text-2xl font-bold text-gray-900">Your Recommended Method</h2>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600 min-h-[44px] min-w-[44px] flex items-center justify-center">
              <X size={24} />
            </button>
          </div>

          <div className="mb-6 p-6 bg-gradient-to-br from-green-50 to-emerald-50 border-2 border-green-300 rounded-lg">
            <div className="flex items-start gap-4">
              <span className="text-5xl">{quizRecommendation.icon}</span>
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">{quizRecommendation.name}</h3>
                <p className="text-gray-700 mb-3">{quizRecommendation.description}</p>
                <div className="space-y-2 text-sm">
                  <p className="text-gray-700">
                    <strong className="text-green-700">✓ Best for:</strong> {quizRecommendation.bestFor}
                  </p>
                  <p className="text-gray-700">
                    <strong className="text-green-700">✓ Pros:</strong> {quizRecommendation.pros}
                  </p>
                  <p className="text-gray-700">
                    <strong className="text-amber-700">⚠ Cons:</strong> {quizRecommendation.cons}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
            <p className="text-sm text-blue-900">
              <strong>✨ Great news!</strong> We've already selected this method for you. Just fill in your financial data and click "Calculate Valuation" to see your results.
            </p>
          </div>

          <button
            onClick={onClose}
            className="w-full bg-blue-600 text-white py-3 px-4 rounded-lg hover:bg-blue-700 transition-colors font-semibold min-h-[44px]"
          >
            Continue to Calculator
          </button>
        </div>
      </div>
    </div>
  );
};

QuizResultModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  quizRecommendation: PropTypes.shape({
    icon: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
    bestFor: PropTypes.string,
    pros: PropTypes.string,
    cons: PropTypes.string
  })
};

export default QuizResultModal;
